import DebugPanel from './DebugPanel';

export default DebugPanel; 